import { render, staticRenderFns } from "./loginView.vue?vue&type=template&id=a2b64c44&scoped=true&"
import script from "./loginView.vue?vue&type=script&lang=js&"
export * from "./loginView.vue?vue&type=script&lang=js&"
import style0 from "./loginView.vue?vue&type=style&index=0&id=a2b64c44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b64c44",
  null
  
)

export default component.exports